export default "__VITE_ASSET__Cz7C5B_H__"